import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_127: FaireProductEntity = {
  token: "legacy_prod_abbott-127",
  type: "product",
  name: "Bell Shaped Cloche-6 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/065bd030b5584ef5ca4254e1beb71fc6b0c7e0e399531379ede6cabd04a79015.jpeg",
  priceDollars: 32,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
